import credenciados from '@/data/credenciados'

export default {
  namespaced: true,
  state: {
    credenciado: null,
    credenciados: [],
    loading: false,
    error: null,
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setCredenciados: (state, credenciados) => state.credenciados = credenciados
  },
  actions: {
    ['initCredenciados']({commit}) {
      commit('setCredenciados', credenciados)
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getCredenciado: state => state.credenciado,
    getCredenciados: state => state.credenciados,
  }
}
